export default {
  name: 'PopupPickerCpt',
  components: {},
  props: {
    columns: {
      type: Array,
      require: true
    },
    columnsFieldNames: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    showView() {
      this.show = true;
    },
    onConfirmClick({
      selectedValues,
      selectedOptions
    }) {
      this.$emit('onPopupPickerSelect', selectedValues, selectedOptions);
      this.show = false;
    },
    onCancelClick() {
      this.show = false;
    }
  }
};